import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class FarmHasEquipmentModel extends BaseModel {

    constructor() {
        super({
                name: "farm_has_equipment",
                tableName: 'farm_has_equipment',
                label: "Thiết bị trong trang trại",
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: "id",
                    display: false
                },
                equipment_id: { 
                    name: 'equipment_id',
                    display: false
                },
                farm_id: { 
                    name: 'farm_id',
                    display: false
                }

            },
            )
    }

}